import React from "react";
import { useConverters } from "./../../pm-converters/context.js";
import { VerticalEmbedViewer } from "../viewer/vertical-embed-viewer.js";
const AppEmbed = ({ settings, node }) => {
  const converters = useConverters();
  const ricosNode = converters.fromPmNode(node.toJSON());
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    VerticalEmbedViewer,
    {
      nodeId: node.attrs.id,
      componentData: ricosNode.appEmbedData,
      settings,
      helpers: {}
    }
  ));
};
export {
  AppEmbed
};
//# sourceMappingURL=component.js.map
